import { call, put, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";
import {
  GET_QRPAYMENTREPORTS,
  POST_QRPAYMENTREPORT,
} from "resources/actionTypes";
import {
  getQrPaymentReportList,
  requestQrPaymentReport,
} from "services/QrPaymentReportService";

// ── Fetch report list ─────────────────────────────────────────────────────────

function* fetchQrPaymentReports(action) {
  const payload = action.payload || {};
  const result = yield call(getQrPaymentReportList, payload);
  if (result?.success) {
    yield put({
      type: GET_QRPAYMENTREPORTS.GET_QRPAYMENTREPORTS_SUCCESS,
      qrPaymentList: result,
    });
  } else {
    yield put({
      type: GET_QRPAYMENTREPORTS.GET_QRPAYMENTREPORTS_FAILED,
      message: result?.message,
    });
    toast.error(result?.message || "Failed to fetch QR payment report");
  }
}

export function* fetchQrPaymentReportsWatcher() {
  yield takeEvery(
    GET_QRPAYMENTREPORTS.GET_QRPAYMENTREPORTS_REQUESTED,
    fetchQrPaymentReports,
  );
}

// ── Request export / email ────────────────────────────────────────────────────

function* postQrPaymentReportSaga(action) {
  const payload = action.payload || {};
  const result = yield call(requestQrPaymentReport, payload);
  if (result?.success) {
    yield put({ type: POST_QRPAYMENTREPORT.POST_QRPAYMENTREPORT_SUCCESS });
    if (payload?.notifyOnComplete) {
      toast.success("Report will be sent to your email once ready");
    } else {
      toast.success("Report requested successfully");
      // If the caller passed a navigate function, redirect to report-generate
      if (typeof payload?.navigate === "function") {
        payload.navigate("/report-generate");
      }
    }
  } else {
    yield put({
      type: POST_QRPAYMENTREPORT.POST_QRPAYMENTREPORT_FAILED,
      message: result?.message,
    });
    toast.error(result?.message || "Failed to request QR payment report");
  }
}

export function* postQrPaymentReportWatcher() {
  yield takeEvery(
    POST_QRPAYMENTREPORT.POST_QRPAYMENTREPORT_REQUESTED,
    postQrPaymentReportSaga,
  );
}
